import React from 'react';
import './quality.css';
import WhatsAppButton from '../components/whatsapp';

export default function Quality() {
    return (
        <div className="quality-container">
            <div className="background-image"></div>
            <div className="title">
                <h2>QUALITY POLICY</h2>
            </div>
            <div className="content">
                <p>
                    We at Panther Exim ensure to maintain high standard quality for all our products. Our consistent efforts to deliver products with high standards and grades from the beginning of the journey to today is the story of our success and recognition.
                </p>
                <p>
                    Today, our company is one of the leading Indian establishments to have adapted and certified its progress according to the strict regulatory standard:
                </p>
                <ul>
                    <li>QUALITY (ISO 9001:2015)</li>
                    <li>ENVIRONMENT (ISO 14001:2015)</li>
                    <li>HEALTH & SAFETY (OHSAS 45001:2018)</li>
                    <li>PRODUCT STANDARD</li>
                </ul>
                <p>
                    Quality assurance at PANTHER EXIM begins with an understanding of customer requirements and continues until the customer is completely satisfied with the delivery of products and services.
                </p>
                <p>
                    Our fundamental principles are the delivery of standard products through well-defined quality control procedures.
                </p>
                <p>
                    PANTHER EXIM is built on a results-based work culture to meet client needs in terms of cost, quality and delivery. We also believe in the continuous improvement of the efficiency of the quality management system and the emphasis on measurement and results.
                </p>
                <p>
                    By improving the efficiency of plant personnel and equipment in a safe manner, we aim for zero loss.
                </p>
                <p>
                    Quality is key focus for us. Our sound infrastructure and committed plant personnel aid us in maintaining our quality standards. We ensure the use of the finest quality materials for our products.
                </p>
            </div>

            <WhatsAppButton />
        </div>
    );
}
